var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolcardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5EA4D3;}\n\t.st1{fill:#2E2E2E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2155_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2157_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2159_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2164_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360,157.8L256,88.5l-104,69.3v66.3H360V157.8z M256,203c-17,0-30.7-13.7-30.7-30.7      c0-17,13.7-30.7,30.7-30.7c17,0,30.7,13.7,30.7,30.7C286.7,189.2,273,203,256,203z",
    id: "XMLID_2180_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,332.1c-25.4,0-46,20.6-46,46v103.5H302V378.1C302,352.7,281.4,332.1,256,332.1z",
    id: "XMLID_2179_"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 49.5,
    id: "XMLID_2178_",
    width: 49.5,
    x: 116.4,
    y: 389.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.5,269.8c-2.2,0-3.9,0.8-5.1,2.4c-1.2,1.6-1.8,3.7-1.8,6.2v5.9c0,2.6,0.6,4.7,1.9,6.3      c1.2,1.6,3,2.4,5.2,2.4c2.2,0,4-0.8,5.2-2.4c1.3-1.6,1.9-3.7,1.9-6.3v-5.9c0-2.5-0.6-4.6-1.9-6.2      C307.5,270.6,305.7,269.8,303.5,269.8z",
    id: "XMLID_2177_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272,269.8c-2.2,0-3.9,0.8-5.1,2.4c-1.2,1.6-1.8,3.7-1.8,6.2v5.9c0,2.6,0.6,4.7,1.9,6.3      c1.2,1.6,3,2.4,5.2,2.4c2.2,0,4-0.8,5.2-2.4c1.3-1.6,1.9-3.7,1.9-6.3v-5.9c0-2.5-0.6-4.6-1.9-6.2      C276,270.6,274.2,269.8,272,269.8z",
    id: "XMLID_2176_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M417.3,233H94.7c-7.2,0-13,5.8-13,13v235.6h118.3V378.9c0-30.7,24.4-56.3,55.1-56.8      c31.2-0.5,56.8,24.8,56.8,55.9v103.5h118.3V246C430.3,238.8,424.5,233,417.3,233z M171.8,444.9h-61.4v-61.4h61.4V444.9z       M189.9,295.7c-2.2,1.6-5,2.4-8.6,2.4c-3.5,0-6.5-0.9-9-2.6c-2.5-1.7-3.7-4.3-3.7-7.8l0-0.1h6.3c0,1.9,0.6,3.3,1.7,4.2      c1.1,0.9,2.7,1.4,4.6,1.4c1.7,0,3.1-0.4,4-1.1c0.9-0.7,1.4-1.7,1.4-2.9c0-1.3-0.4-2.3-1.3-3c-0.9-0.8-2.4-1.5-4.6-2.1      c-3.8-1.1-6.6-2.5-8.5-4c-1.9-1.5-2.9-3.6-2.9-6.3c0-2.7,1.1-4.8,3.3-6.5c2.2-1.7,5-2.5,8.4-2.5c3.6,0,6.5,0.9,8.7,2.7      c2.2,1.8,3.3,4.2,3.2,7.1l0,0.1h-6.3c0-1.6-0.5-2.9-1.5-3.7c-1-0.9-2.4-1.3-4.1-1.3c-1.6,0-2.9,0.4-3.7,1.2      c-0.9,0.8-1.3,1.8-1.3,3c0,1.1,0.5,2,1.4,2.7c1,0.7,2.6,1.5,4.9,2.2c3.6,1,6.3,2.3,8.2,4c1.9,1.6,2.8,3.8,2.8,6.4      C193.2,291.9,192.1,294.1,189.9,295.7z M222.4,275.9h-6.3c0-2.1-0.5-3.6-1.5-4.7s-2.6-1.5-4.7-1.5c-1.9,0-3.5,0.8-4.6,2.4      s-1.6,3.6-1.6,6.1v6.5c0,2.5,0.6,4.5,1.7,6.1s2.8,2.4,4.8,2.4c1.9,0,3.4-0.5,4.4-1.5c1-1,1.4-2.6,1.4-4.7h6.3l0,0.1      c0.1,3.5-1,6.2-3.2,8.1c-2.2,2-5.2,2.9-9,2.9c-3.9,0-7-1.3-9.4-3.8c-2.4-2.5-3.6-5.7-3.6-9.7v-6.5c0-4,1.2-7.2,3.5-9.7      c2.3-2.5,5.4-3.8,9.2-3.8c4,0,7.1,1,9.3,2.9c2.2,1.9,3.3,4.7,3.3,8.2L222.4,275.9z M253.4,297.7h-6.5v-13.5h-13.2v13.5h-6.5      v-32.5h6.5v14h13.2v-14h6.5V297.7z M285.7,284.3c0,4-1.3,7.3-3.8,9.9c-2.5,2.6-5.8,3.9-9.8,3.9c-4,0-7.3-1.3-9.8-3.9      c-2.5-2.6-3.8-5.9-3.8-9.9v-5.8c0-4,1.2-7.3,3.7-9.9c2.5-2.6,5.7-3.9,9.7-3.9c4,0,7.3,1.3,9.8,3.9c2.5,2.6,3.8,5.9,3.8,9.9      V284.3z M317.1,284.3c0,4-1.3,7.3-3.8,9.9s-5.8,3.9-9.8,3.9c-4,0-7.3-1.3-9.8-3.9c-2.5-2.6-3.8-5.9-3.8-9.9v-5.8      c0-4,1.2-7.3,3.7-9.9c2.5-2.6,5.7-3.9,9.7-3.9c4,0,7.3,1.3,9.8,3.9c2.5,2.6,3.8,5.9,3.8,9.9V284.3z M322.3,265.1h6.5v27.5h14.6      v5h-21.1V265.1z M401.6,444.9h-61.4v-61.4h61.4V444.9z",
    id: "XMLID_2166_"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 49.5,
    id: "XMLID_2165_",
    width: 49.5,
    x: 346.1,
    y: 389.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2160_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257,174h-4.6v-23.4c0-1.3,1-2.3,2.3-2.3l0,0c1.3,0,2.3,1,2.3,2.3V174z",
    id: "XMLID_2163_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.5,175.2l-1.5-2.8l18.9-10.2c0.8-0.4,1.7-0.1,2.2,0.6l0,0c0.4,0.8,0.1,1.7-0.6,2.2      L255.5,175.2z",
    id: "XMLID_2162_"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 254.8,
    cy: 171.7,
    id: "XMLID_2161_",
    r: 5.5
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 17.2,
    id: "XMLID_2158_",
    width: 388.2,
    x: 61.9,
    y: 488.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.4,99.5v-53h58.7V12h-58.7v-1.4c0-2.5-2.1-4.6-4.6-4.6c-2.5,0-4.6,2.1-4.6,4.6v88.9   H261.4z",
    id: "XMLID_2156_"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolcardicon);
export default __webpack_public_path__ + "static/media/schoolcardicon.32e182f8b231e0d100dee2edd3b9c43d.svg";
export { ForwardRef as ReactComponent };